import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 200px;
`;

const Text = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 151.8%;
  text-align: center;
`;

const Blackhole = styled.img`
  height: 144px;
  width: 137px;
  margin-bottom: 20px;
`;

interface ExperiencesNotFoundProps {
  children?: React.ReactNode | React.ReactNode[];
}

export const ExperiencesNotFound = ({ children }: ExperiencesNotFoundProps) => {
  return (
    <Container>
      <Blackhole src={'/explore/blackhole.png'} alt={'no experiences image'} />
      {children || (
        <Text>
          Oops! We can&apos;t seem to find an experience that fits your selection. You can try
          another filter to expand your options.
        </Text>
      )}
    </Container>
  );
};
